module.exports = __webpack_public_path__ + "img/padronet_celebracio_v2_groc_120_x_120_pixels_500_milisegons.01de7cfe.gif";